/* eslint-disable */
// import external dependencies
import 'lazysizes'
import 'picturefill'
import 'picturefill/dist/plugins/mutation/pf.mutation'

// Import everything from autoload


import fontface from './fontface'
import Swup from 'swup'
import JsPlugin from '@swup/js-plugin'
import SwupGaPlugin from '@swup/ga-plugin'
import SwupGiaPlugin from '@swup/gia-plugin'
import SwupDebugPlugin from '@swup/debug-plugin'

// Gia modules and componenets
import loadComponents from 'gia/loadComponents'
import modules from './modules'
import components from './components'
// Swup transitions
import transitions from './transitions'

// Merge modules and components for gia
const elements = { ...modules, ...components }

loadComponents(elements)

// Init Swup if not logged in
// if (!document.body.classList.contains('admin-bar')) {
//   const swup = new Swup({
//     animateHistoryBrowsing: true,
//     plugins: [
//       // new SwupDebugPlugin(),
//       new SwupGaPlugin(),
//       new SwupGiaPlugin({
//         components: elements,
//         log: true,
//       }),
//       new JsPlugin(transitions),
//     ],
//   })
// } else {
//   loadComponents(elements)
// }

// Add class to add button of Gravity Form
const GFButtons = document.querySelectorAll('.gpnf-add-entry')
if (GFButtons) GFButtons.forEach(e => e.classList.add('button'))



// WEBPACK FOOTER //
// ./scripts/main.js